import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  select(event) {
    if (!event.target.checked) return;
    this.element.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      if (input !== event.target && input.dataset.community === event.target.dataset.community) input.checked = false;
    });
  }
}
